const routes = [
  {
    layout: "AuthLayout",
    path: "/auth",
    childrens: [
      {
        element: "Login",
        childPath: "/login",
      },
      {
        element: "ForgotPassword",
        childPath: "/forgotPassword",
      },
      {
        element: "CreateNewPassword",
        childPath: "/createNewPassword",
      },
      {
        element: "Success",
        childPath: "/success",
      },
      {
        element: "Redirect",
        childPath: "/redirect",
      },
      {
        element: "DeleteAccount",
        childPath: "/delete-account",
      },
      {
        element: "DeleteUser",
        childPath: "/delete-user",
      },
    ],
  },
  {
    layout: "MainLayout",
    path: "/admin",
    childrens: [
      {
        element: "AdminComponents",
        childPath: "/",
      },
      {
        element: "AdminDashboard",
        childPath: "/dashboard",
      },
      {
        element: "UserProfile",
        childPath: "/profile",
      },
      {
        element: "UsersComponent",
        childPath: "/users",
      },
      {
        element: "ManageAdminComponent",
        childPath: "/manageAdmins",
      },
      // {
      //     element: "ProductCatalog",
      //     childPath: "/product-catalog"
      // },
      {
        element: "ProductEnquiry",
        childPath: "/product-enquiry",
      },
      {
        element: "ResourcesComponent",
        childPath: "/resources",
      },
      {
        element: "LoyaltyProgram",
        childPath: "/loyalty-program",
      },
      {
        element: "ContactForm",
        childPath: "/contactForm",
      },
      {
        element: "ManageContent",
        childPath: "/manageContent",
      },
      {
        element: "ManageNotification",
        childPath: "/notification",
      },
      {
        element: "Qrcode",
        childPath: "/qrcode",
      },
      {
        element: "Rewards",
        childPath: "/rewards",
      },
      {
        element: "ReportDownload",
        childPath: "/report",
      },
      {
        element: "ProductCatalog",
        childPath: "/product-catalog",
      },
      {
        element: "Feedback",
        childPath: "/feedback",
      },
      {
        element: "RedeemRewards",
        childPath: "/redeemRewards"
      },
      {
        element: "RetailerTod",
        childPath: "/retailer-tod",
      },
      {
        element: "AddPoints",
        childPath: "/add-points",
      },
      {
        element: "AppAnalytics",
        childPath: "/appAnalytics",
      },
      {
        element : "ManageUserRoles",
        childPath : "/manageUserRoles"
      }
    ],
  },
  {
    path: "/",
    redirect: "/auth/login",
  },
  {
    path: "*",
    redirect: "/page404",
  },
];

export default routes;
